// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3YB-w","title":"ClientInsurance_title__3QxpS","itemText":"ClientInsurance_itemText__3jfqS"};